import API from '../api'
import postUrl from './paths'

export const createLead = (userId, lead) =>
    new Promise((resolve, reject) => {
        API.post(postUrl.createLead, { ...lead }, { userId })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })

export const addTaskReminder = (leadId, body) =>
    new Promise((resolve, reject) => {
        API.post(postUrl.addTaskReminder, { ...body }, { leadId })
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })